import { Pipe, PipeTransform, inject } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';

@Pipe({ name: 'glxyMarkdown', standalone: true })
export class GlxyMarkdownPipe implements PipeTransform {
  private markdownService = inject(MarkdownService);
  transform(message: string | null | undefined) {
    if (!message) {
      return '';
    }
    return this.markdownService.parse(message) as string;
  }
}
